import React from 'react'
import { useStore } from '../../common/Context'
import Button from './Button'

function Toasts() {
    const [state, dispatch] = useStore()

    if (!state.toasts?.length) return <></>

    return (
        <div className={`toasts ${state.toasts.length ? 'show' : ''} `}>
            {state.toasts.map((toast) => {
                return (
                    <div
                        key={toast.date}
                        className={`toast ${toast.messageType.toLowerCase()}`}
                    >
                        <span>
                            {toast.text}

                            {toast.counter > 1 && <>&nbsp;(x{toast.counter})</>}

                            {toast.action && (
                                <>
                                    &nbsp;
                                    <Button
                                        link
                                        onClick={() => {
                                            toast.action.onClick()
                                            dispatch({
                                                type: 'CLEAR_TOAST',
                                                payload: toast.date,
                                            })
                                        }}
                                        text={toast.action.label}
                                    ></Button>
                                </>
                            )}
                        </span>

                        <button
                            onClick={() =>
                                dispatch({
                                    type: 'CLEAR_TOAST',
                                    payload: toast.date,
                                })
                            }
                            className={`clear-toast`}
                        >
                            &#10005;
                        </button>
                    </div>
                )
            })}
        </div>
    )
}

export default Toasts
